import React from 'react';
import {useTranslation} from 'react-i18next';
import {
	LinkAgentRegDoc,
	LinkAgentRequirement,
	LinkAgentPOGIS,
	LinkSharePointRegDoc1,
	LinkSharePointRegDoc2,
	LinkSharePointRequirement,
	LinkSharePointPOGIS,
	LinkDataDescription,
} from './CoPiltPageConstants';

export const CoPilotPage = () => {
	const {t} = useTranslation('features/copilotintegration');

	const createRow = (td1: JSX.Element, td2: JSX.Element) => {
		return (
			<tr>
				<td style={{minWidth: 250}}>{td1}</td>
				<td>{td2}</td>
			</tr>
		);
	};

	const createAtag = (link: string, text: string) => {
		return (
			<a href={link} target='_blank'>
				{text}
			</a>
		);
	};

	const createTable = (
		heading: JSX.Element,
		regdoc: JSX.Element,
		req: JSX.Element,
		pogis: JSX.Element,
	) => {
		const rows: JSX.Element[] = [];

		rows.push(
			createRow(<th>{t('copilotPage.table.data')}</th>, <th>{heading}</th>),
		);
		rows.push(createRow(t('copilotPage.table.regulatoryDocuments'), regdoc));
		rows.push(createRow(t('copilotPage.table.requirements'), req));
		rows.push(createRow(t('copilotPage.table.pogisDocuments'), pogis));
		return (
			<table style={{padding: 10, marginLeft: 20, border: '1px black solid'}}>
				{rows}
			</table>
		);
	};

	const createAgentsTable = () => {
		return createTable(
			t('copilotPage.table.agents'),
			createAtag(
				LinkAgentRegDoc,
				t('copilotPage.table.regulatoryDocumentsLink'),
			),
			createAtag(LinkAgentRequirement, t('copilotPage.table.requirementsLink')),
			createAtag(LinkAgentPOGIS, t('copilotPage.table.pogisLink')),
		);
	};

	const createSPDataTable = () => {
		return createTable(
			t('copilotPage.table.sources'),
			<>
				{createAtag(
					LinkSharePointRegDoc1,
					t('copilotPage.table.regulatoryDocumentsSPLink1'),
				)}
				<br />
				{createAtag(
					LinkSharePointRegDoc2,
					t('copilotPage.table.regulatoryDocumentsSPLink2'),
				)}
			</>,
			createAtag(
				LinkSharePointRequirement,
				t('copilotPage.table.requirementsSPLink'),
			),
			createAtag(LinkSharePointPOGIS, t('copilotPage.table.pogisSPLink')),
		);
	};

	return (
		<div style={{paddingLeft: 20, maxWidth: 900}}>
			<h2>{t('copilotPage.title')}</h2>

			<p>{t('copilotPage.intro')}</p>
			{createAgentsTable()}
			<p>
				<strong>{t('copilotPage.important')}</strong>
			</p>

			<p>
				{t('copilotPage.settings')}
				<br />
				<br />
				{t('copilotPage.pinHint')}
			</p>

			<h3>{t('copilotPage.purpose.title')}</h3>
			<p>{t('copilotPage.purpose.text')}</p>

			<h3>{t('copilotPage.dataSource.title')}</h3>
			<p>{t('copilotPage.dataSource.text')}</p>
			{createSPDataTable()}
			<p>
				{t('copilotPage.dataSource.description')}&nbsp;
				<a href={LinkDataDescription} target='_blank'>
					{t('copilotPage.dataSource.descriptionLink')}
				</a>
			</p>
			<h3>{t('copilotPage.roadmap.title')}</h3>
			<p>{t('copilotPage.roadmap.text')}</p>

			<h3>{t('copilotPage.reuse.title')}</h3>
			<p>{t('copilotPage.reuse.text')}</p>
			<ul>
				<li>{t('copilotPage.reuse.items.0')}</li>
				<li>{t('copilotPage.reuse.items.1')}</li>
				<li>{t('copilotPage.reuse.items.2')}</li>
			</ul>

			<h3>{t('copilotPage.accessRights.title')}</h3>
			<p>{t('copilotPage.accessRights.text')}</p>
			<ul>
				<li>{t('copilotPage.accessRights.group')}</li>
			</ul>
		</div>
	);
};
